import * as projectTaskStatusMethods from '../../utils/api/invite-recruit/projectTaskStatusData';

function* requestUpdateTaskStatus(payload) {
  projectTaskStatusMethods.requestUpdateTaskStatus(payload.payload);
}

export  { requestUpdateTaskStatus }